import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Loading from './components/Loading/Loading';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import routes from './routes';

const App = () => {
  return (
    <Router>
      <div data-testid="app">
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <Routes>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<route.component />}
                  exact={route.exact}
                />
              ))}
            </Routes>
          </Suspense>
          <Footer />
        </ErrorBoundary>
      </div>
    </Router>
  );
};



export default App;
